<!-- Toast de mensajes -->
<p-toast position="top-right" key="msj"></p-toast>

<!-- Confirmación estándar -->
<p-confirmDialog [style]="{ width: '50vw' }" [baseZIndex]="10000" acceptLabel="Aceptar" rejectLabel="Cancelar"
  rejectButtonStyleClass="p-button-text">
</p-confirmDialog>

<!-- Confirmación sin botón de cancelar -->
<p-confirmDialog key="sinInformacionDialog" [style]="{ width: '50vw' }" [baseZIndex]="10000" acceptLabel="Aceptar"
  rejectLabel="Cancelar" rejectButtonStyleClass="p-button-text" styleClass="color-confirmar" [rejectVisible]="false">
</p-confirmDialog>

<!-- Contenedor principal -->
<div class="container-fluid" style="border-color: #1e5a9c;">
  <div class="row">
    <div class="col-md-12 mt-2">
      <div class="card card-shadow sinborde">

        <!-- Encabezado -->
        <div class=" sinborde mt-2" style="background: none; position: relative;">
          <div class="cardicono rounded">
            <i class="pi pi-file-excel mt-3" style="font-size: 2rem; color: #fff;"></i>
          </div>
          <header class="titulo-header">
            Concentrado
            <div style="color: #1e5a9c; display: inline;"> Reportes de Nomina</div>
          </header>
        </div>
        <br>
        <br>

        <!-- <div class="reporteria-container mt-5 ">
          <section class="reportes-area">
            <div class="card">
              <div class="row">
                <div class="col-md-6 row">
                  <div class="col-md-5">
                    <input ngModel="fec_inicio" type="date" class="form-control sinborde"
                      pTooltip="Seleccione o teclee fecha Inicio" tooltipPosition="top" [style]="{ width: '100%' }" />
                      <hr class="style-two2">
                  </div>
                  <div class="col-md-5">
                    <input ngModel="fec_fin" type="date" class="form-control sinborde"
                      pTooltip="Seleccione o teclee fecha Fin" tooltipPosition="top" [style]="{ width: '100%' }" />
                      <hr class="style-two2">
                  </div>


                </div>


                <div class="col-md-6 flex justify-content-end row">
                  <div class="col-md-5"></div>


                  <div class="col-md-5  ">
                    <p-calendar [(ngModel)]="anio_filtro" view="year" [showIcon]="true" dateFormat="yy"
                      inputId="yearpicker" pTooltip="Año de Semanas a Consultar" tooltipPosition="top">
                    </p-calendar>
                  </div>

                  Botón "Cargar"
                    <div class="col-md-2 align-content-center">
                    <button pButton pRipple label="Cargar" class="custom-delll" icon="pi pi-filter"
                      (click)="cargarListadoDeSemanasAnio_cast(anio_filtro)" pTooltip="Cargar Semanas del Año">
                    </button>
                  </div>
                </div>
              </div>

            </div>
          </section>
        </div> -->

        <!-- Contenido principal -->
        <div class="reporteria-container  mt-5">
          <section class="reportes-area">
            <div class="card">
              <div class="reportes-grid">
                <div *ngFor="let reporte of reportes" class="reporte-card">
                  <h3>
                    <i class="pi pi-file-excel" style="font-size: 2rem; color: #217346;"></i>
                    {{ reporte.titulo }}
                  </h3>

                  <p [ngClass]="{'texto_sm':true}">{{ reporte.descripcion }}</p>

                  <!-- Fechas -->
                  <div class="row mb-2" *ngIf="reporte.id_reporte!==5">
                    <div class="col-4">
                      <input [(ngModel)]="reporte.fec_inicio" type="date" class="form-control sinborde"
                        pTooltip="Seleccione o teclee fecha Inicio" tooltipPosition="top" [style]="{ width: '90%' }" />

                    </div>
                    <div class="col-4">
                      <input [(ngModel)]="reporte.fec_fin" type="date" class="form-control sinborde"
                        pTooltip="Seleccione o teclee fecha Fin" tooltipPosition="top" [style]="{ width: '90%' }" />
                    </div>
                    <div class="col-4">
                      <p-dropdown *ngIf="reporte.id_reporte !== 4"[ngClass]="{'texto_sm2': true, 'dropdown-compact': true}" 
                        [options]="lstciudadeshm"
                        autoWidth="false" [style]="{'width': '100%'}" placeholder="Seleccionar"
                        [(ngModel)]="reporte.ciudad" optionLabel="nombre" [showClear]="false" optionValue="id">
                      </p-dropdown>
                      <p-dropdown *ngIf="reporte.id_reporte == 4"[ngClass]="{'texto_sm2': true, 'dropdown-compact': true}" 
                        [options]="lstciudadesprin"
                        autoWidth="false" [style]="{'width': '100%'}" placeholder="Seleccionar"
                        [(ngModel)]="reporte.ciudad" optionLabel="nombre" [showClear]="false" optionValue="id">
                      </p-dropdown>
                    </div>
                  </div>
                  <div class="row mb-2" *ngIf="reporte.id_reporte==5">
                    <div class="col-4">
                      <p-dropdown [ngClass]="{'texto_sm2': true, 'dropdown-compact': true}" [options]="lstAniosInfo"
                        autoWidth="false" [style]="{'width': '100%'}" placeholder="Seleccionar"
                        [(ngModel)]="reporte.num_anio" optionLabel="anio" [showClear]="false" optionValue="anio"
                        (onChange)="this.semanasLst(reporte.num_anio)">
                      </p-dropdown>
                    </div>
                    <div class="col-4">
                      <p-dropdown [ngClass]="{'texto_sm2': true, 'dropdown-compact': true}" [options]="lstSemanasInfo"
                        autoWidth="false" [style]="{'width': '100%'}" placeholder="Seleccionar"
                        [(ngModel)]="reporte.id_semana" optionLabel="nombre" [showClear]="false" optionValue="id"
                        [disabled]="lstSemanasInfo.length===0"
                        pTooltip="Seleccione Semana">
                      </p-dropdown>
                    </div>
                    <div class="col-4">
                      <p-dropdown [ngClass]="{'texto_sm2': true, 'dropdown-compact': true}" [options]="lstciudadeshm"
                        autoWidth="false" [style]="{'width': '100%'}" placeholder="Seleccionar"
                        [(ngModel)]="reporte.ciudad" optionLabel="nombre" [showClear]="false" optionValue="id">
                      </p-dropdown>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6 mx-auto">
                      <button  class="custom-button w-100" (click)="verReporte(reporte.id_reporte, reporte.fec_inicio, reporte.fec_fin, reporte.ciudad,reporte.id_semana,reporte.num_anio)" [disabled]="loading" >
                        Generar&nbsp;Reporte
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <!-- Fin contenido principal -->

      </div>
    </div>
  </div>
</div>
